import officialFeedback from './officialFeedback'
import platformFeedback from './platformFeedback'
import userResearch from './userResearch'
export default {
  namespaced: true,
  modules: {
    officialFeedback,
    platformFeedback,
    userResearch,
  },
}
